module.exports = __webpack_public_path__ + "static/media/check.23b3e801.svg";